
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import useUserFBPermissions from '@/hooks/swr/useUserFBPermissions';
//Hooks
import useUser from '@/utils/hooks/swr/useUser';
import Button from '@/components/base/Button';
import H3 from '@/components/base/Headings/H3';
import Loader from '@/components/base/Loader';
// Components
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import DataAccessForm from '@/components/pages/settings/DataAccessForm';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';
// Endpoints
import { SOCIAL_PROFILES } from '@/routes/privateRoutes';
const SideContent = () => {
    const { t } = useTranslation('settings');
    return (<div className="p-8 xl:px-7 xl:py-10">
            <H3 className="mb-m">{t('data_access_page.additional_column.your_social_profiles')}</H3>
            <p className="mb-8 font-GSemiBold text-xs leading-4 text-icoGray-500 dark:text-icoDarkMode-wolf">
                {t('data_access_page.additional_column.your_social_profiles_notice')}
            </p>
            <Button as={Link} href={SOCIAL_PROFILES} className="w-full" size="md" variant="secondary">
                {t('data_access_page.additional_column.go_to_social_profiles')}
            </Button>
        </div>);
};
const MainContent = () => {
    const { user, isLoading: isUserLoading } = useUser();
    const { user: userFbPermissions, isLoading: isUserFBLoading, mutate } = useUserFBPermissions({ params: { update: '1' } });
    if (isUserLoading || isUserFBLoading) {
        return (<div className="flex min-h-72 items-center justify-center">
                <Loader className="h-8 w-8 text-icoBlue"/>
            </div>);
    }
    return <DataAccessForm user={user} userFbPermissions={userFbPermissions} mutate={mutate}/>;
};
const PageContent = () => {
    return (<SettingsWrapper>
            <SettingsWrapper.MainContent>
                <MainContent />
            </SettingsWrapper.MainContent>
            <SettingsWrapper.SideContent>
                <SideContent />
            </SettingsWrapper.SideContent>
        </SettingsWrapper>);
};
export default function DataAccess() {
    return (<WrapperSwitchLayout noPadding={true} disableMainScroll={true}>
            <PageContent />
        </WrapperSwitchLayout>);
}

    async function __Next_Translate__getStaticProps__19a39aea4cf__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/settings/data-access',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19a39aea4cf__ as getStaticProps }
  